// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

export const ROUTE_NAMES = {
  BOTS_MANAGEMENT: 'bots-management'
}

const ROUTES = {
  [ROUTE_NAMES.BOTS_MANAGEMENT]: {
    name: ROUTE_NAMES.BOTS_MANAGEMENT,
    path: 'bots'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.BOTS_MANAGEMENT].name,
    path: ROUTES[ROUTE_NAMES.BOTS_MANAGEMENT].path,
    component: (resolve) => require(['./views/bots'], resolve)
  }
]
